import { createContext, useContext } from "react";

import { IListDictionary } from "../types/list";

export const ListContext = createContext<IListDictionary | undefined>(undefined);

export function useListContext() {
    const list = useContext(ListContext);

    if (list === undefined) {
        throw new Error("Error: useListContext is undefined. useListContext must be used inside a ListContext.Provider");
    } else {
        return list;
    }
}
